<template>
  <div class="c-header-header-mobile">
    <div class="c-header-header-mobile__main">
      <div class="c-header-header-mobile__buttons-left">
        <button
          type="button"
          class="c-header-header-mobile__button"
          @click="$emit('menu-button-clicked')"
        >
          <i class="icon-menu"></i>
        </button>
      </div>

      <a class="c-header-header-mobile__logo" :href="routes.root">
        <img
          :src="logoUrl"
          alt="Francfranc online"
          width="116"
          height="28"
          loading="lazy"
        />
      </a>
      <div class="c-header-header-mobile__buttons-right">
        <button-cart :href="routes.cart" :cart-count="cartCount"></button-cart>
      </div>
    </div>

    <h1 v-if="renderH1" class="c-header-header-mobile__h1">
      家具・インテリア雑貨ならFrancfranc（フランフラン）
    </h1>

    <div class="c-header-header-mobile__search-input" ref="searchInput">
      <search-input-mobile
        :placeholder="placeholder"
        @search-focus="handleSearchFocus"
      ></search-input-mobile>
    </div>
  </div>
</template>

<script>
import ButtonCart from '~/js/components/header/buttonCart'
import SearchInputMobile from '~/js/components/header/searchInputMobile'

export default {
  name: 'ComponentHeaderHeaderMobile',
  components: {
    ButtonCart,
    SearchInputMobile,
  },
  props: {
    cartCount: { type: Number, default: 0 },
    logoUrl: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    renderH1: { type: Boolean, default: false },
    routes: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  mounted() {
    this.emitThreshold()
  },
  methods: {
    emitThreshold() {
      this.$emit('threshold-changed', this.$refs.searchInput.offsetTop)
    },
    handleSearchFocus() {
      this.$emit('search-button-clicked')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-header-mobile {
  &__main {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 variables.$padding-side-mobile;
    height: 64px;
    align-items: center;
  }

  &__buttons-left,
  &__buttons-right {
    width: 60px;
  }

  &__buttons-right {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }

  &__button {
    font-size: 22px;
    display: inline-block;
    padding: 4px;
  }

  &__h1 {
    color: variables.$color-brown;
    font-weight: 300;
    font-size: 10px;
    padding: 0 variables.$padding-side-mobile;
    margin-top: 4px;
    width: 100%;
  }

  &__search-input {
    padding: 8px variables.$padding-side-mobile;
  }
}
</style>
